module.exports = __webpack_public_path__ + "img/grey.c26fe43.svg";